
export function getDistanceFromTop() {
    return window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
}

export function getElemPosition(elem) {
    // return elem.getBoundingClientRect()

    if (document.body !== null) {

        let body = document.body.getBoundingClientRect(),
            elemRect = elem.getBoundingClientRect(),
            top = elemRect.top - body.top;

        return {
            top
        }

    }
}

export function getElemHeight(elem) {
    return elem.offsetHeight
}


export function getElemDimensions(elem) {
    
    const width = elem.offsetWidth
    const height = elem.offsetHeight
    
    return {
        width,
        height
    }
}

